module.exports = __webpack_public_path__ + "static/media/hu.a3828659.svg";